import Url from "./snake.lib.url.js";

export default class Router {
    static get = (uri, callback) => {
        const currentUri = Url.getCurrentUri();

        if (currentUri && currentUri === uri) callback();
    };
}
